import useAppModalEffects from 'src/components/Modals/hooks/useAppModalEffects';
import AccountModals from 'src/components/Modals/groups/AccountModals';
import CollateralModals from 'src/components/Modals/groups/CollateralModals';
import DetailsModals from 'src/components/Modals/groups/DetailsModals';
import DevModals from 'src/components/Modals/groups/DevModals';
import LiquidityModals from 'src/components/Modals/groups/LiquidityModals';
import TradingModals from 'src/components/Modals/groups/TradingModals';
import UserModals from 'src/components/Modals/groups/UserModals';
import WarningModals from 'src/components/Modals/groups/WarningModals';
import AnnouncementModals from './AnnouncementModals';

export default function AppModals() {
	useAppModalEffects();

	return (
		<>
			<AccountModals />
			<CollateralModals />
			<DetailsModals />
			<DevModals />
			<LiquidityModals />
			<TradingModals />
			<UserModals />
			<WarningModals />
			<AnnouncementModals />
		</>
	);
}
